import React from 'react';
import { formatPrice } from '@/shared/utils/priceFormatter';
import type { PayViaLinkDetailsVm } from '../viewModels/payViaLink.vm';

interface OrderSummaryProps {
  details: PayViaLinkDetailsVm;
}

export const OrderSummary: React.FC<OrderSummaryProps> = ({ details }) => {
  return (
    <div className="bg-white border border-[#0000001A] rounded-lg p-6 shadow-sm space-y-4">
      <h2 className="text-base font-bold text-[#011E38] border-b border-gray-100 pb-3">
        Order Summary
      </h2>

      <div className="text-xs text-gray-500 font-semibold flex flex-col space-y-1">
        <span>Merchant:</span>
        <span className="text-sm font-bold text-[#011E38]">{details.merchantName}</span>
      </div>

      <div className="flex justify-between text-xs font-medium text-gray-500 pt-2 border-t border-gray-50">
        <span>Total items ({details.totalItems})</span>
        <span className="text-[#011E38] font-bold">{formatPrice(details.amount)}</span>
      </div>

      <div className="flex justify-between text-base font-bold text-[#011E38] border-t border-gray-100 pt-3.5">
        <span>Total Payable</span>
        <span>{formatPrice(details.amount)}</span>
      </div>
    </div>
  );
};

export default OrderSummary;
